import SectionBanner from './SectionBanner';
export default SectionBanner;
